// components/auth/RequireAuth.js
import React from 'react';
import { useUserContext } from '../../context/UserContext';
import Unauthorized from './Unauthorized';
import { Outlet } from 'react-router-dom';

const RequireAuth = () => {
    const { token } = useUserContext();

    return token ? <Outlet /> : <Unauthorized />;
};

export default RequireAuth;
